import { Phone, PhoneOff } from "react-feather";
import styles from "./identityVoice.module.css";

const IdentityIncomingCallModal = ({
  call,
  callerName,
  callerAvatar,
  onAccept,
  onDecline,
}) => {
  if (!call) return null;

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    const first = parts[0] ? parts[0].charAt(0).toUpperCase() : "";
    const last = parts[parts.length - 1] ? parts[parts.length - 1].charAt(0).toUpperCase() : "";
    return first + last || "?";
  };

  return (
    <div className={`${styles.IncomingOverlay}`}>
      <div className={`${styles.CallBar} CallBar`}>
        <div className={`${styles.CallBarAvatar}`}>
          {callerAvatar && callerAvatar !== "" ? (
            <img src={callerAvatar} alt="" />
          ) : (
            <p>{getInitials(callerName)}</p>
          )}
        </div>
        
        <div className={`${styles.CallBarDetails}`}>
          <p className={`${styles.Name}`}>{callerName || "Unknown Caller"}</p>
          <p className={`${styles.StatusText}`} style={{ color: "#ff8271" }}>
            Incoming call…
          </p>
        </div>

        <div style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
          <button
            className={`${styles.IncomingDeclineBU}`}
            onClick={() => {
              call.reject();
              onDecline && onDecline();
            }}
          >
            <PhoneOff />
          </button>
          <button
            className={`${styles.IncomingAcceptBU}`}
            onClick={() => {
              call.accept();
              onAccept && onAccept(call);
            }}
          >
            <Phone />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdentityIncomingCallModal;
